import React from 'react';
import PixelatedInput from './pixelated_input.js';

const SetupForm = ({setUsername}) => {

    return (
        <div>
        <h2>Link Your MyAnimeList Profile</h2>
        <PixelatedInput
            placeholder={"Your username"}
            onEnter={setUsername} />
        </div>
    );
};

export default SetupForm;
